<script setup>
import Icon from '@/Components/Icon/index.vue';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { THEMES } from '@/constants';

const props = defineProps({
  imageSet: {
    type: Object,
    required: false,
  },
  altText: {
    type: String,
    default: '',
  },
  link: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    default: "md",
    validator: (v) =>
      [
        "md",
        "lg",
        "fit"
      ].indexOf(v) !== -1,
  },
  fallbackIcon: {
    type: String,
    required: false,
  }
});

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

const style = {
  md: "h-16 w-16",
  lg: "h-24 w-24",
  full: "w-fit",
};

const imageUrl =  computed(() => {
  if(!props.imageSet && !props.imageSet?.original) {
    return null;
  }

  return props.imageSet.original;
});

const imgClasses = computed(() => [
  'object-contain rounded-md p-1',
  theme == THEMES.STUDY_AUS && 'border border-primary-700 border-solid',
  theme == THEMES.STUDY_QLD && 'border border-primary-700 border-solid',
  theme == THEMES.STUDY_MELB && page.component === 'Enquiry' && 'border border-primary-700 border-solid',
]);
</script>

<template>
  <div class="mb-3">
    <component :is="link ? 'a' : 'div'" tabindex="-1" :href="link">
      <template v-if="imageUrl">
        <img
          :src="imageUrl"
          :alt="altText"
          :class="[style[size], imgClasses]"
        >
      </template>
      <template v-else>
        <div :class="style[size]" class="flex items-center justify-center">
          <Icon v-if="fallbackIcon" :path="fallbackIcon" :aria-label="altText" :height="40" :width="40" />
        </div>
      </template>
    </component>
  </div>
</template>